import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>

        {/* Main Footer Row */}
        <Row className="footer-main-row">

          {/* Left: Logo + Tagline */}
          <Col lg={5} md={12} className="footer-brand-col">
            <div className="footer-logo-wrap">
              <img
                src="/assets/images/logo2.webp"
                alt="Azamra"
                className="footer-logo"
              />
            </div>
            <p className="footer-tagline">
              The leading platform for tokenized real-world asset investments in Africa.
            </p>
          </Col>

          {/* Right: Nav Columns */}
          <Col lg={7} md={12} className="footer-nav-col">
            <Row className="justify-content-between">

              {/* Company */}
              <Col xs="auto" className="footer-links-col">
                <h4 className="footer-links-heading">Company</h4>
                <ul className="footer-links-list">
                  <li><a href="/about-us" className="footer-link">About Us</a></li>
                  <li><a href="/contact" className="footer-link">Contact Us</a></li>
                </ul>
              </Col>

              {/* Our Products & Services */}
              <Col xs="auto" className="footer-links-col">
                <h4 className="footer-links-heading">Our Products & Services</h4>
                <ul className="footer-links-list">
                  <li><a href="/treasury-solutions" className="footer-link">Treasury Solutions</a></li>
                  <li><a href="/investment-solution" className="footer-link">Investment Solutions</a></li>
                  <li><a href="/marketplace" className="footer-link">Marketplace</a></li>
                </ul>
              </Col>

              {/* Platform */}
              <Col xs="auto" className="footer-links-col">
                <h4 className="footer-links-heading">Platform</h4>
                <ul className="footer-links-list">
                  <li>
                    <a href="https://www.linkedin.com/company/105882666/" target="_blank" rel="noopener noreferrer" className="footer-link footer-social-link">
                      <img src="/linkedin.webp" alt="Linkedin" className="footer-social-icon" />
                      Linkedin
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/Azamrafintech/" target="_blank" rel="noopener noreferrer" className="footer-link footer-social-link">
                      <img src="/facebook.webp" alt="Facebook" className="footer-social-icon" />
                      Facebook
                    </a>
                  </li>
                </ul>
              </Col>

              {/* Legal */}
              <Col xs="auto" className="footer-links-col">
                <h4 className="footer-links-heading">Legal</h4>
                <ul className="footer-links-list">
                  <li><a href="/terms-of-service" className="footer-link">Terms Of Service</a></li>
                  <li><a href="/privacy-policy" className="footer-link">Privacy Policy</a></li>
                  <li><a href="/risk-disclosure" className="footer-link">Risk Disclosure</a></li>
                </ul>
              </Col>

            </Row>
          </Col>

        </Row>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom: Copyright */}
        <div className="footer-bottom">
          <p className="footer-copyright">© 2026 Azamra. All rights reserved.</p>
        </div>

      </Container>
    </footer>
  );
};

export default Footer;
